var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "navbar" },
      [
        _c("div", { staticClass: "logo " }),
        _c("hamburger", {
          staticClass: "hamburger-container",
          attrs: {
            "toggle-click": _vm.toggleSideBar,
            "is-active": _vm.sidebar.opened
          }
        }),
        _c(
          "el-menu",
          {
            staticClass: "left-menu ",
            attrs: { mode: "horizontal" },
            on: { select: _vm.handSelect }
          },
          [
            _c(
              "el-menu-item",
              {
                staticClass: "active-text-color",
                attrs: { index: "dashboard" }
              },
              [
                _c("svg-icon", { attrs: { "icon-class": "index" } }),
                _vm._v(" 系统首页 ")
              ],
              1
            ),
            _vm.alarmNum > 0
              ? _c(
                  "el-menu-item",
                  { attrs: { index: "1046" } },
                  [
                    _c(
                      "el-badge",
                      { attrs: { value: _vm.alarmNum, max: 99 } },
                      [
                        _c("svg-icon", { attrs: { "icon-class": "bjgl" } }),
                        _vm._v(" 告警系统 ")
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "el-menu-item",
                  { attrs: { index: "1046" } },
                  [
                    _c("svg-icon", { attrs: { "icon-class": "bjgl" } }),
                    _vm._v(" 告警系统 ")
                  ],
                  1
                )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "right-menu" },
          [
            _c(
              "el-tooltip",
              {
                attrs: {
                  effect: "dark",
                  content: "回到大屏",
                  placement: "bottom"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "avatar-container right-menu-item",
                    on: { click: _vm.main }
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "avatar-wrapper" },
                      [
                        _c(
                          "svg-icon",
                          {
                            staticClass: "user-avatar",
                            attrs: { "icon-class": "index" }
                          },
                          [_vm._v("首页")]
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
            ),
            _c(
              "el-tooltip",
              {
                attrs: {
                  effect: "dark",
                  content: _vm.$t("navbar.screenfull"),
                  placement: "bottom"
                }
              },
              [_c("screenfull", { staticClass: "screenfull right-menu-item" })],
              1
            ),
            _c(
              "el-tooltip",
              {
                attrs: { effect: "dark", content: "退出", placement: "bottom" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "avatar-container right-menu-item",
                    on: { click: _vm.logout }
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "avatar-wrapper" },
                      [
                        _c("svg-icon", {
                          staticClass: "user-avatar",
                          attrs: { "icon-class": "tuichu" }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }